import { Heading1, Paragraph } from "@sb1/ffe-core-react";
import { type FunctionComponent, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import StackTrace from "stacktrace-js";
import type { FallbackProps } from "react-error-boundary";
import MenneskeSklir from "$IMAGES/Menneske_person_voksen_skli_på_bananskall.svg";
import { logError } from "~/shared/api/server";
import useCustomer from "~/shared/api/useCustomer";
import { Grid, GridCol, GridRow } from "~/shared/components/ffe-grid";
import dispatchers from "~/shared/dispatchers";
import { useNavigate } from "~/shared/hooks/use-navigate";
import mbc from "~/shared/functions/mbc";
import { BackButton } from "~/shared/components/ffe-buttons";

export const ErrorPage: FunctionComponent<FallbackProps> = ({ error, resetErrorBoundary }) => {
	const [feilreferanse, setFeilreferanse] = useState<string>();
	const kunde = useCustomer();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const onBackButtonClick = () => {
		dispatchers.clearError()(dispatch);
		resetErrorBoundary();
		if (mbc.isNative()) navigate("/");
		else window.location.href = "/privat/forsikring/pensjon";
	};

	const lagreError = (error: Error) => {
		StackTrace.fromError(error).then((mappedStack) => {
			return logError({
				url: document.URL,
				message: error.message,
				mappedStack: mappedStack.map((sf) => sf.toString()).join("\n"),
			}).then((res) => {
				setFeilreferanse(`Feilreferanse: ${res.msgToken}`);
			});
		});
	};

	useEffect(() => {
		lagreError(error instanceof Error ? error : new Error(String(error)));
	}, []);

	return (
		<Grid bgColor="subtle" className="ppm-grid">
			{kunde.authenticated && (
				<GridRow className="ppm-margin-bottom--64">
					<GridCol>
						<div className="ppm-portal-back-button__wrapper">
							<BackButton onClick={onBackButtonClick}>Til Min pensjon</BackButton>
						</div>
					</GridCol>
				</GridRow>
			)}
			<GridRow>
				<GridCol md={{ cols: 8, offset: 2 }} centerText={true}>
					<Heading1>Ups! Systemet vårt snublet litt.</Heading1>
					<Paragraph lead={true}>Vi retter opp i det nå – prøv igjen snart.</Paragraph>
					<img className="ppm-margin-top--40 ppm-margin-bottom--40" alt="" src={MenneskeSklir} style={{ width: "55%" }} />
				</GridCol>
			</GridRow>
			{feilreferanse && (
				<GridRow>
					<GridCol center={true}>
						<Paragraph>{feilreferanse}</Paragraph>
					</GridCol>
				</GridRow>
			)}
		</Grid>
	);
};
export default ErrorPage;
